import React from "react";

import email from "../../../../../assets/images/telegram.png";
import twitter from "../../../../../assets/images/twitter.png"

const Footer = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <div className="Ray---Connect---Links">
        <div className="text-center">
          <a href="https://t.me/flokicoinpulse" target="blank">
            <i className="fab fa-twitter">
              <img src={email} />
            </i>
          </a>
          &nbsp;
          &nbsp;
          <a href="https://twitter.com/FlokicoinPulse" target="blank">
            <i className="fab fa-instagram">
              <img src={twitter} />
            </i>
          </a>
        </div>
      </div>
    </div>
  );
};
export default Footer;
